import React, { useState, useEffect } from 'react';
import { FaTooth, FaSmile, FaTeethOpen, FaRegGrinStars, FaRegGrinBeam, FaRegGrinAlt, FaRegGrin, FaRegGrinTongue, FaRegGrinHearts, FaRegGrinSquint, FaRegGrinBeamSweat, FaRegGrinWink, FaRegGrinTears, FaRegGrinStars as FaImplant, FaRegGrinAlt as FaCrown, FaRegGrinBeam as FaComposite, FaRegGrin as FaEndo, FaRegGrinTongue as FaProtesis, FaRegGrinHearts as FaLimpieza, FaRegGrinSquint as FaSellante, FaRegGrinBeamSweat as FaSensibilidad, FaRegGrinWink as FaPlaca, FaRegGrinTears as FaExpansor, FaRegGrinStars as FaFluor, FaRegGrinAlt as FaExtraccion, FaRegGrinBeam as FaOrtodoncia, FaRegGrin as FaAlineador, FaPhoneAlt, FaWhatsapp, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { MdOutlineCleaningServices, MdOutlineBraces, MdOutlineDentistry, MdOutlineHealthAndSafety, MdOutlineRemoveCircleOutline, MdOutlineAddCircleOutline, MdOutlineCheckCircleOutline, MdOutlineVisibilityOff, MdOutlineVisibility, MdOutlineBrush, MdOutlineEmojiEmotions, MdOutlineEmojiObjects, MdOutlineEmojiNature, MdOutlineEmojiPeople, MdOutlineEmojiSymbols, MdOutlineEmojiTransportation, MdOutlineEmojiFoodBeverage, MdOutlineEmojiEvents, MdOutlineEmojiFlags, MdOutlineEmojiObjects as MdImplant, MdOutlineEmojiNature as MdCrown, MdOutlineEmojiPeople as MdComposite, MdOutlineEmojiSymbols as MdEndo, MdOutlineEmojiTransportation as MdProtesis, MdOutlineEmojiFoodBeverage as MdLimpieza, MdOutlineEmojiEvents as MdSellante, MdOutlineEmojiFlags as MdSensibilidad, MdOutlineAddCircleOutline as MdPlaca, MdOutlineRemoveCircleOutline as MdExpansor, MdOutlineCheckCircleOutline as MdFluor, MdOutlineVisibility as MdExtraccion, MdOutlineBraces as MdOrtodoncia, MdOutlineVisibilityOff as MdAlineador } from 'react-icons/md';
import BookingModal from './BookingModal';
import SEO from './SEO';

const servicios = [
  {
    titulo: 'Odontología General',
    descripcion: 'Prevención, diagnóstico y tratamiento de problemas dentales comunes para toda la familia.',
    icono: (
      <svg className="w-10 h-10 mx-auto mb-2 text-[#1B65A6]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 21c-4.418 0-8-3.582-8-8V7a4 4 0 014-4h8a4 4 0 014 4v6c0 4.418-3.582 8-8 8z" /></svg>
    )
  },
  {
    titulo: 'Ortodoncia',
    descripcion: 'Corrección de la posición de los dientes y mejora de la estética dental con tecnología moderna.',
    icono: (
      <svg className="w-10 h-10 mx-auto mb-2 text-[#1B65A6]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M4 12h16M4 16h16M4 8h16" /></svg>
    )
  },
  {
    titulo: 'Implantología',
    descripcion: 'Reemplazo de piezas dentales perdidas con implantes de alta calidad y resultados naturales.',
    icono: (
      <svg className="w-10 h-10 mx-auto mb-2 text-[#1B65A6]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 2v20m6-6H6" /></svg>
    )
  }
];

const testimonios = [
  {
    texto: 'Excelente atención y profesionalismo. Mi familia y yo confiamos plenamente en Clínica Rhelmü.',
    autor: 'María González'
  },
  {
    texto: 'Me ayudaron a perder el miedo al dentista. ¡100% recomendados!',
    autor: 'Juan Pérez'
  }
];

const HomePage = ({ onLoginClick, onCitaAgendada }) => {
  const [showBooking, setShowBooking] = React.useState(false);
  // Estado para validación de formulario de contacto
  const [contact, setContact] = useState({ nombre: '', telefono: '', email: '', mensaje: '' });
  const [contactTouched, setContactTouched] = useState({ nombre: false, telefono: false, email: false, mensaje: false });
  const [contactStatus, setContactStatus] = useState(null); // 'success' | 'error' | null
  const [contactLoading, setContactLoading] = useState(false);
  
  // Estado para el carrusel de testimonios
  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);

  const testimonios = [
    {
      texto: "Fui por una urgencia y me atendieron el mismo día. Todo el equipo fue muy amable, me explicaron todo paso a paso. Súper agradecida.",
      autor: "Daniela Reyes"
    },
    {
      texto: "Nunca había ido al dentista sin nervios hasta que llegué acá. El trato fue muy cercano y me sentí tranquila en todo momento.",
      autor: "Felipe Morales"
    },
    {
      texto: "Muy buena atención, puntuales y profesionales. Me hicieron un presupuesto claro desde el principio, sin sorpresas.",
      autor: "Carolina Fuentes"
    },
    {
      texto: "Llevé a mi papá a una evaluación y quedamos impresionados con la dedicación del doctor. Se tomaron el tiempo de explicarnos todo con paciencia.",
      autor: "Jorge Arancibia"
    },
    {
      texto: "Tenía una mala experiencia previa en otra clínica, pero acá fue totalmente distinto. Me sentí escuchada y bien cuidada.",
      autor: "Alejandra Silva"
    },
    {
      texto: "El lugar es muy limpio y moderno. Me hice una limpieza dental y todo el proceso fue rápido, sin dolor y con excelentes resultados.",
      autor: "Tomás Riquelme"
    },
    {
      texto: "Lo que más valoro es que no me hicieron esperar y la atención fue directa al grano, pero con mucha amabilidad. Se nota que saben lo que hacen.",
      autor: "Francisca Leiva"
    },
    {
      texto: "Me recomendaron esta clínica y no me arrepiento. Desde la recepción hasta el especialista, todo impecable. Volveré sin duda.",
      autor: "Matías Soto"
    }
  ];

  // Efecto para cambiar testimonios automáticamente
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonialIndex((prevIndex) => 
        prevIndex === testimonios.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // Cambia cada 4 segundos

    return () => clearInterval(interval);
  }, [testimonios.length]);

  // Función para cambiar testimonio manualmente
  const goToTestimonial = (index) => {
    setCurrentTestimonialIndex(index);
  };

  // Función para siguiente testimonio
  const nextTestimonial = () => {
    setCurrentTestimonialIndex((prevIndex) => 
      prevIndex === testimonios.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Función para testimonio anterior
  const prevTestimonial = () => {
    setCurrentTestimonialIndex((prevIndex) => 
      prevIndex === 0 ? testimonios.length - 1 : prevIndex - 1
    );
  };

  // Validaciones simples
  const isValidNombre = contact.nombre.trim().length > 2;
  const isValidTelefono = /^\+?\d{8,15}$/.test(contact.telefono.trim().replace(/\s/g, ''));
  const isValidEmail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(contact.email.trim());
  const isValidMensaje = contact.mensaje.trim().length > 5;

  const handleContactChange = e => {
    setContact({ ...contact, [e.target.name]: e.target.value });
  };
  const handleContactBlur = e => {
    setContactTouched({ ...contactTouched, [e.target.name]: true });
  };
  const handleContactSubmit = e => {
    e.preventDefault();
    setContactTouched({ nombre: true, telefono: true, email: true, mensaje: true });
    if (isValidNombre && isValidTelefono && isValidEmail && isValidMensaje) {
      setContactLoading(true);
      setTimeout(() => {
        setContactStatus('success');
        setContactLoading(false);
        setContact({ nombre: '', telefono: '', email: '', mensaje: '' });
        setContactTouched({ nombre: false, telefono: false, email: false, mensaje: false });
        setTimeout(() => setContactStatus(null), 3000);
      }, 1200);
    } else {
      setContactStatus('error');
      setTimeout(() => setContactStatus(null), 2500);
    }
  };
  return (
    <div className="min-h-screen bg-[#F2F2F2] flex flex-col font-sans pt-[70px]">
      <SEO 
        title="Inicio - RHELMU"
        description="Clínica dental RHELMU en Concepción. Especialistas en ortodoncia, estética dental, implantes y más. Agenda tu cita online con presupuesto gratis."
        keywords="clínica dental, ortodoncia, estética dental, implantes, Concepción, odontología, brackets, alineadores, blanqueamiento dental"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "MedicalBusiness",
          "name": "Clínica RHELMU",
          "description": "Clínica dental especializada en ortodoncia y estética dental en Concepción",
          "url": "https://rhelmu.cl",
          "telephone": "+569 4443 5569",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Cochrane 635, PISO 10 - 1002",
            "addressLocality": "Concepción",
            "addressRegion": "Bío Bío",
            "addressCountry": "CL"
          },
          "openingHours": "Mo-Fr 10:00-19:00, Sa 10:00-14:00",
          "medicalSpecialty": "Ortodoncia",
          "availableService": [
            {
              "@type": "MedicalService",
              "name": "Ortodoncia",
              "description": "Corrección de la alineación dental con brackets o alineadores"
            },
            {
              "@type": "MedicalService", 
              "name": "Estética Dental",
              "description": "Mejora de la forma, color y brillo de la sonrisa"
            },
            {
              "@type": "MedicalService",
              "name": "Implantes",
              "description": "Reemplazo de dientes perdidos con implantes"
            }
          ],
          "sameAs": [
            "https://www.facebook.com/ortodonciarhelmu/",
            "https://www.instagram.com/ortodonciarhelmu/"
          ]
        }}
      />
      
      {/* Header tipo barra informativa */}
      <header className="bg-white text-[#1B65A6] py-3 px-8 flex flex-col md:flex-row justify-between items-center border-b border-[#E0E0E0] gap-2 md:gap-0 fixed top-0 left-0 w-full z-50 shadow-md">
        <div className="flex items-center gap-2 text-sm font-medium">
          {/* Icono dirección */}
          <svg className="w-5 h-5 text-[#05C7F2]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0l-4.243-4.243a8 8 0 1111.314 0z" /><circle cx="12" cy="10" r="3" /></svg>
          <span>Cochrane 635, PISO 10 - 1002, Concepción, Bío Bío</span>
        </div>
        <div className="flex items-center gap-2 text-sm font-medium">
          {/* Icono horario */}
          <svg className="w-5 h-5 text-[#05C7F2]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6l4 2" /></svg>
          <span>Lu – Vi 10:00 - 19:00 · Sáb 10:00 - 14:00</span>
        </div>
        <div className="flex items-center gap-6 text-sm font-medium">
          <span>+569 4443 5569</span>
          <button
            onClick={onLoginClick}
            className="ml-4 bg-[#05C7F2] text-[#1B65A6] font-semibold px-5 py-1.5 rounded-full shadow hover:bg-[#1B65A6] hover:text-white transition text-sm"
          >
            Iniciar Sesión
          </button>
        </div>
      </header>

      {/* Hero Section */}
      <section
        className="flex flex-col md:flex-row items-center justify-between px-8 py-16 md:py-24 gap-12 border-b border-[#E0E0E0]"
        style={{
          backgroundImage: "url('/rhelmu-banner.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
        }}
      >
        {/* Overlay blanco semitransparente para legibilidad */}
        <div style={{
          position: 'absolute',
          inset: 0,
          background: 'rgba(255,255,255,0.7)',
          zIndex: 1,
        }} />
        <div className="md:w-1/2 space-y-8" style={{position: 'relative', zIndex: 2}}>
                      <h1 className="text-5xl md:text-6xl font-extrabold text-[#1B65A6] leading-tight" style={{fontFamily: 'Quicksand, Montserrat, Arial, sans-serif'}}>
              En Clínica Rhelmü<br />
              <span style={{color: '#1199c6', fontSize: '0.7em'}}>Tu Sonrisa, Tu Confianza... Tu RHELMÜ</span>
            </h1>
          <p className="text-xl text-gray-700 max-w-xl">
            Nos especializamos en la prevención y el bienestar dental de toda tu familia. Agenda tu diagnóstico gratis y vive la mejor experiencia en salud bucal.
          </p>
          <button className="bg-[#1B65A6] text-white font-bold px-10 py-4 rounded-full shadow-lg hover:bg-[#05C7F2] hover:text-[#1B65A6] transition text-xl btn-pulse" onClick={() => setShowBooking(true)}>
            Agenda tu hora
          </button>
          {/* Frase animada de presupuestos gratis */}
          <div className="mt-6 w-full flex justify-start">
            <span
              style={{
                animation: 'pulse 1.2s infinite',
                fontSize: '2rem',
                fontWeight: 'bold',
                color: '#1199c6',
                display: 'inline-block',
              }}
            >
              ¡Presupuestos gratis para todos los pacientes nuevos!
            </span>
          </div>
        </div>
        <div className="md:w-1/2 flex justify-center" style={{position: 'relative', zIndex: 2}}>
          <img 
            src="/logo-rhelmu.png" 
            alt="Clínica RHELMU - Sistema de Gestión Dental" 
            className="h-72 md:h-96 object-contain drop-shadow-xl logo-hero"
            loading="eager"
            fetchPriority="high"
          />
        </div>
      </section>

      {/* Servicios tipo grid limpio */}
      <section className="bg-[#F2F2F2] py-16 px-8">
        <h2 className="text-4xl font-bold text-[#1B65A6] text-center mb-12">Nuestros Servicios</h2>
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10">
          {/* Ortodoncia */}
          <div className="flex flex-col items-center text-center bg-white rounded-2xl border border-[#e0e7ef] shadow-xl card-lift p-6 cursor-pointer">
            <FaTooth className="w-14 h-14 mb-3 text-[#1B65A6]" />
            <span className="font-bold text-lg mb-2">Ortodoncia</span>
            <span>Corrección de la alineación dental con brackets o alineadores modernos y discretos.</span>
          </div>
          {/* Estética Dental */}
          <div className="flex flex-col items-center text-center bg-white rounded-2xl border border-[#e0e7ef] shadow-xl card-lift p-6 cursor-pointer">
            <FaSmile className="w-14 h-14 mb-3 text-[#1B65A6]" />
            <span className="font-bold text-lg mb-2">Estética Dental</span>
            <span>Mejora la forma, color y brillo de tu sonrisa con técnicas avanzadas y seguras.</span>
          </div>
          {/* Restauraciones */}
          <div className="flex flex-col items-center text-center bg-white rounded-2xl border border-[#e0e7ef] shadow-xl card-lift p-6 cursor-pointer">
            <FaCrown className="w-14 h-14 mb-3 text-yellow-500" />
            <span className="font-bold text-lg mb-2">Restauraciones</span>
            <span>Reparación y reconstrucción de dientes dañados con materiales estéticos y duraderos.</span>
          </div>
          {/* Endodoncia */}
          <div className="flex flex-col items-center text-center bg-white rounded-2xl border border-[#e0e7ef] shadow-xl card-lift p-6 cursor-pointer">
            <FaEndo className="w-14 h-14 mb-3 text-green-600" />
            <span className="font-bold text-lg mb-2">Endodoncia</span>
            <span>Tratamiento de conducto para eliminar infecciones y conservar tus piezas dentales.</span>
          </div>
          {/* Implantes */}
          <div className="flex flex-col items-center text-center bg-white rounded-2xl border border-[#e0e7ef] shadow-xl card-lift p-6 cursor-pointer">
            <FaImplant className="w-14 h-14 mb-3 text-red-500" />
            <span className="font-bold text-lg mb-2">Implantes</span>
            <span>Reemplazo de dientes perdidos con soluciones fijas, estéticas y funcionales.</span>
          </div>
          {/* Prótesis */}
          <div className="flex flex-col items-center text-center bg-white rounded-2xl border border-[#e0e7ef] shadow-xl card-lift p-6 cursor-pointer">
            <FaProtesis className="w-14 h-14 mb-3 text-purple-600" />
            <span className="font-bold text-lg mb-2">Prótesis</span>
            <span>Soluciones removibles o fijas para restaurar la función y estética de tu boca.</span>
          </div>
          {/* Limpieza Dental */}
          <div className="flex flex-col items-center text-center bg-white rounded-2xl border border-[#e0e7ef] shadow-xl card-lift p-6 cursor-pointer">
            <FaLimpieza className="w-14 h-14 mb-3 text-[#8B5C2A]" />
            <span className="font-bold text-lg mb-2">Limpieza Dental</span>
            <span>Eliminación de placa, sarro y manchas para prevenir enfermedades y mantener tu sonrisa sana.</span>
          </div>
          {/* Sellantes */}
          <div className="flex flex-col items-center text-center bg-white rounded-2xl border border-[#e0e7ef] shadow-xl card-lift p-6 cursor-pointer">
            <FaSellante className="w-14 h-14 mb-3 text-[#8B5C2A]" />
            <span className="font-bold text-lg mb-2">Sellantes</span>
            <span>Protección preventiva contra caries para niños y adultos.</span>
          </div>
        </div>
      </section>

      {/* Testimonios tipo carrusel sobre fondo celeste */}
      <section className="bg-[#05C7F2] py-16 px-8">
        <h2 className="text-4xl font-bold text-white text-center mb-12">Nuestros Pacientes Opinan</h2>
        <div className="max-w-4xl mx-auto relative">
          {/* Contenedor del carrusel */}
          <div className="relative overflow-hidden rounded-xl">
            {/* Testimonio actual */}
            <div 
              className="bg-white rounded-xl shadow-lg p-8 text-[#1B65A6] transition-all duration-500 ease-in-out transform"
              style={{
                opacity: 1,
                transform: 'translateX(0)'
              }}
            >
              <div className="text-center">
                <span className="quote text-6xl text-[#05C7F2] block mb-4">"</span>
                <p className="italic text-lg mb-6 leading-relaxed">
                  {testimonios[currentTestimonialIndex].texto}
                </p>
                <div className="flex items-center justify-center mb-4">
                  <span className="star text-yellow-400 text-xl">★</span>
                  <span className="star text-yellow-400 text-xl">★</span>
                  <span className="star text-yellow-400 text-xl">★</span>
                  <span className="star text-yellow-400 text-xl">★</span>
                  <span className="star text-yellow-400 text-xl">★</span>
                </div>
                <span className="font-bold text-lg">– {testimonios[currentTestimonialIndex].autor}</span>
              </div>
            </div>
          </div>

          {/* Botones de navegación */}
          <button
            onClick={prevTestimonial}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-3 shadow-lg hover:bg-[#1B65A6] hover:text-white transition-all duration-300 z-10"
            aria-label="Testimonio anterior"
          >
            <FaChevronLeft className="w-6 h-6" />
          </button>
          
          <button
            onClick={nextTestimonial}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-3 shadow-lg hover:bg-[#1B65A6] hover:text-white transition-all duration-300 z-10"
            aria-label="Siguiente testimonio"
          >
            <FaChevronRight className="w-6 h-6" />
          </button>

          {/* Indicadores de puntos */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonios.map((_, index) => (
              <button
                key={index}
                onClick={() => goToTestimonial(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentTestimonialIndex 
                    ? 'bg-white scale-125' 
                    : 'bg-white/50 hover:bg-white/75'
                }`}
                aria-label={`Ir al testimonio ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Beneficios de la clínica */}
      <section className="bg-[#F2F2F2] py-16 px-8">
        <h2 className="text-3xl font-bold text-[#1B65A6] text-center mb-12" style={{fontFamily: 'Quicksand, Montserrat, Arial, sans-serif'}}>¿Por qué elegirnos?</h2>
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
          <div className="bg-white rounded-2xl shadow p-6 flex flex-col items-center text-center beneficio-anim">
            <span className="beneficio-icon">🛡️</span>
            <h3 className="font-bold text-lg mb-2">Atención Especializada y Segura</h3>
            <p>Contamos con tecnología avanzada y un enfoque empático para atender a personas con ansiedad o temor al dentista.</p>
          </div>
          <div className="bg-white rounded-2xl shadow p-6 flex flex-col items-center text-center beneficio-anim">
            <span className="beneficio-icon">👨‍⚕️</span>
            <h3 className="font-bold text-lg mb-2">Equipo Profesional y Eficiente</h3>
            <p>Nuestro equipo integral permite realizar todos los tratamientos necesarios en un solo lugar, sin demoras.</p>
          </div>
          <div className="bg-white rounded-2xl shadow p-6 flex flex-col items-center text-center beneficio-anim">
            <span className="beneficio-icon">💳</span>
            <h3 className="font-bold text-lg mb-2">Opciones de Pago Flexibles</h3>
            <p>Ofrecemos distintos métodos de pago y convenios con previsión para facilitar el acceso a tu tratamiento.</p>
          </div>
          <div className="bg-white rounded-2xl shadow p-6 flex flex-col items-center text-center beneficio-anim">
            <span className="beneficio-icon">💰</span>
            <h3 className="font-bold text-lg mb-2">Primera Evaluación Accesible</h3>
            <p>Evaluamos tu caso de manera clara y transparente. Contamos con condiciones especiales para distintos tipos de atención y tratamientos personalizados.</p>
          </div>
          <div className="bg-white rounded-2xl shadow p-6 flex flex-col items-center text-center beneficio-anim">
            <span className="beneficio-icon">😊</span>
            <h3 className="font-bold text-lg mb-2">Trato Cercano y Humano</h3>
            <p>Te acompañamos con calidez y dedicación durante todo tu proceso. Queremos que te sientas cómodo y bien atendido.</p>
          </div>
          <div className="bg-white rounded-2xl shadow p-6 flex flex-col items-center text-center beneficio-anim">
            <span className="beneficio-icon">📍</span>
            <h3 className="font-bold text-lg mb-2">Excelente Ubicación</h3>
            <p>Estamos en el corazón de Concepción, a pasos de la plaza de armas. Fácil acceso para todos nuestros pacientes.</p>
          </div>
        </div>
      </section>

      {/* Contacto */}
      <section className="bg-[#05C7F2] py-16 px-4">
        <h2 className="text-4xl font-bold text-white text-center mb-10">Contáctanos</h2>
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row gap-8 items-stretch">
          {/* Formulario y datos */}
          <div className="flex-1 bg-transparent flex flex-col justify-between">
            <div className="mb-6">
              <h3 className="text-2xl font-bold text-white mb-1">Clínica Rhelmü</h3>
              <div className="text-white mb-1">Cochrane 635, Piso 10, Oficina 1002, Concepción, Bío Bío</div>
              <div className="text-white font-semibold mb-6">Teléfonos: <span className="font-normal">+56 9 4443 5569</span></div>
            </div>
            <form className="space-y-4 bg-white rounded-lg shadow-lg p-6 flex flex-col justify-between h-full" onSubmit={handleContactSubmit}>
              <input
                type="text"
                name="nombre"
                placeholder="Nombre"
                className={`w-full border rounded-lg px-4 py-3 text-lg transition-all duration-200 ${contactTouched.nombre ? (isValidNombre ? 'border-green-400' : 'border-red-400') : 'border-gray-300'}`}
                value={contact.nombre}
                onChange={handleContactChange}
                onBlur={handleContactBlur}
              />
              <input
                type="tel"
                name="telefono"
                placeholder="Teléfono"
                className={`w-full border rounded-lg px-4 py-3 text-lg transition-all duration-200 ${contactTouched.telefono ? (isValidTelefono ? 'border-green-400' : 'border-red-400') : 'border-gray-300'}`}
                value={contact.telefono}
                onChange={handleContactChange}
                onBlur={handleContactBlur}
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                className={`w-full border rounded-lg px-4 py-3 text-lg transition-all duration-200 ${contactTouched.email ? (isValidEmail ? 'border-green-400' : 'border-red-400') : 'border-gray-300'}`}
                value={contact.email}
                onChange={handleContactChange}
                onBlur={handleContactBlur}
              />
              <textarea
                name="mensaje"
                placeholder="Mensaje"
                className={`w-full border rounded-lg px-4 py-3 text-lg transition-all duration-200 ${contactTouched.mensaje ? (isValidMensaje ? 'border-green-400' : 'border-red-400') : 'border-gray-300'}`}
                rows={4}
                value={contact.mensaje}
                onChange={handleContactChange}
                onBlur={handleContactBlur}
              ></textarea>
              <button
                type="submit"
                className={`bg-[#05C7F2] text-white font-bold px-8 py-3 rounded-full shadow hover:bg-[#1B65A6] hover:text-white transition text-lg mt-2 flex items-center justify-center ${contactLoading ? 'opacity-60 cursor-not-allowed' : ''}`}
                disabled={contactLoading}
              >
                {contactLoading ? 'Enviando...' : 'ENVIAR'}
              </button>
              {contactStatus === 'success' && (
                <div className="text-green-600 text-center font-bold animate-bounce mt-2">¡Mensaje enviado con éxito!</div>
              )}
              {contactStatus === 'error' && (
                <div className="text-red-500 text-center font-bold animate-pulse mt-2">Por favor, completa todos los campos correctamente.</div>
              )}
            </form>
          </div>
          {/* Mapa */}
          <div className="flex-1 flex items-stretch">
            <iframe
              title="Ubicación Clínica"
              src="https://www.google.com/maps?q=Cochrane+635,+PISO+10+-+1002,+Concepción,+Bío+Bío&output=embed"
              className="w-full h-full min-h-[420px] rounded-lg shadow-lg"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Franja informativa con botón de agendar */}
      <section className="bg-white py-8 px-4">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Icono dental animado */}
          <div className="flex-shrink-0 flex items-center justify-center mb-4 md:mb-0">
            <svg width="70" height="70" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="franja-dental-anim">
              <path d="M16 16C16 10 24 6 32 6C40 6 48 10 48 16C48 22 40 26 32 26C24 26 16 22 16 16Z" stroke="#1B65A6" strokeWidth="3"/>
              <path d="M20 26C20 38 24 58 32 58C40 58 44 38 44 26" stroke="#1B65A6" strokeWidth="3"/>
              <path d="M24 36C28 32 36 32 40 36" stroke="#1B65A6" strokeWidth="3"/>
              <polyline points="18,21 32,32 46,21" stroke="#05C7F2" strokeWidth="2" fill="none"/>
            </svg>
          </div>
          {/* Texto motivacional */}
          <div className="flex-1 text-center md:text-left">
            <span className="text-[#1B65A6] text-xl md:text-2xl font-bold">
              Además de cuidar tu salud bucal, en Clínica Rhelmü nos enfocamos en brindarte una atención integral y humana para mejorar tu calidad de vida, comenzando por tu sonrisa.
            </span>
          </div>
          {/* Botón de agendar animado */}
          <div className="flex-shrink-0 flex items-center justify-center mt-4 md:mt-0">
            <button
              className="bg-[#05C7F2] text-white font-bold px-10 py-4 rounded-2xl shadow-lg hover:bg-[#1B65A6] hover:text-white transition text-lg btn-pulse"
              onClick={() => setShowBooking(true)}
            >
              AGENDA AHORA
            </button>
          </div>
        </div>
      </section>

      {/* Botón flotante de llamada */}
      <a
        href="tel:+56944435569"
        className="fixed bottom-28 right-6 w-16 h-16 bg-[#1B65A6] rounded-full shadow-lg flex items-center justify-center z-50 hover:bg-[#05C7F2] transition"
        title="Llamar a la clínica"
      >
        <FaPhoneAlt className="w-8 h-8 text-white" />
      </a>

      {/* Botón flotante de WhatsApp debajo del de llamada */}
      <a
        href="https://wa.me/56944435569"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 w-16 h-16 bg-[#25D366] rounded-full shadow-xl hover:shadow-2xl flex items-center justify-center z-50 hover:bg-[#128C7E] transition-all duration-300 border-2 border-white"
        title="Contáctanos por WhatsApp"
      >
        <FaWhatsapp className="w-10 h-10 text-white" />
      </a>

      {/* Footer */}
      <footer className="bg-[#23272F] text-white pt-10 pb-4 mt-12">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row md:justify-between md:items-center gap-8 px-4">
          {/* Logo a la izquierda */}
          <div className="flex flex-col items-center md:items-start md:w-1/3">
            <img src="/logo-rhelmu.png" alt="Logo Clínica" className="h-20 w-auto mb-3" />
          </div>
          {/* Datos de contacto a la derecha con iconos */}
          <div className="flex-1 flex flex-col items-center md:items-end text-left md:text-right md:w-2/3 gap-1">
            <h2 className="text-2xl font-bold mb-1">Clínica Rhelmü</h2>
            <div className="flex items-center gap-2 mb-1">
              <svg className="w-5 h-5 text-[#05C7F2]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0l-4.243-4.243a8 8 0 1111.314 0z" /><circle cx="12" cy="10" r="3" /></svg>
              <span>Cochrane 635, Piso 10, Oficina 1002, Concepción, Bío Bío</span>
            </div>
            <div className="flex items-center gap-2 mb-1">
              <svg className="w-5 h-5 text-[#05C7F2]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8" /></svg>
              <span>gerencia.rhelmu@gmail.com</span>
            </div>
            <div className="flex items-center gap-2 mb-1">
              <svg className="w-5 h-5 text-[#05C7F2]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 5h2l.4 2M7 13h10l4-8H5.4M7 13l-1.35 2.7A2 2 0 007.48 19h9.04a2 2 0 001.83-1.3L21 13M7 13l1.5-6h7l1.5 6" /></svg>
              <a href="tel:+56944435569" className="hover:underline text-[#05C7F2]">+56 9 4443 5569</a>
                      
            </div>
          </div>
        </div>
        <div className="text-center text-gray-400 text-xs mt-8">
          2024 © Clínica Rhelmü. Todos los derechos reservados.
        </div>
      </footer>
      <BookingModal open={showBooking} onClose={() => setShowBooking(false)} onBooked={onCitaAgendada} />
    </div>
  );
};

export default HomePage; 